import { render } from "./EmployeesTable.vue?vue&type=template&id=d9049aa4&scoped=true"
import script from "./EmployeesTable.vue?vue&type=script&lang=js"
export * from "./EmployeesTable.vue?vue&type=script&lang=js"

import "./EmployeesTable.vue?vue&type=style&index=0&id=d9049aa4&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9049aa4"]])

export default __exports__